import * as React from "react";
import { Route } from "react-router";

import { Container } from "../../../Container";

import { SensorsDataStore } from "./flux";
import { View } from "./View";
import { TimeSeriesStore } from "../../../../charts/TimeSeries/flux/TimeSeriesStore";
import { Polyglot } from "../../../../polyglot";

interface Props
{
    polyglot: Polyglot;
    store: SensorsDataStore;
    timeSeriesStore: TimeSeriesStore;

    className?: string;
}

export class SensorsDataRoute extends React.Component<Props>
{
    render ()
    {
        return (
            <Route path='/sensors-data' render={() => (
                <Container store={this.props.store}>
                    <View
                        polyglot={this.props.polyglot}
                        className={this.props.className} refId={null} rows={null} axes={null} view={null}
                        hasChartData={null} hasGeoData={null} isMapVisible={null} coordinate={null} tableData={null}
                        timeSeriesStore={this.props.timeSeriesStore}
                    />
                </Container>
            )} />
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/SensorsData/SensorsDataRoute.tsx